<button type="button" mat-icon-button class="close-button" (click)="close()">
	<mat-icon color="accent" svgIcon="close"></mat-icon>
</button>
<div mat-dialog-title class="title-label"><span translate>ecall-off.type-your-exception</span><span>&#58;</span></div>
<mat-form-field mat-dialog-content appearance="outline" class="comment-width">
	<textarea [placeholder]="'ecall-off.comment_placeholder' | translate" rows="8" matInput #commentText [cdkTextareaAutosize]="false" maxlength="512" [(ngModel)]="comment"></textarea>
	<mat-hint class="copo-textarea-hint" align="end">{{commentText.value.length ||
		0}}/512
	</mat-hint>
	<mat-hint><span translate>ecall-off.comment_instruction</span></mat-hint>
</mat-form-field>

<mat-dialog-actions class="button-group">
	<button type="submit" cdkFocusInitial mat-button [mat-dialog-close]="true" class="copo-blue-dark-grey-button" (click)="save()">
		<span translate>datacenter.save</span>
	</button>
</mat-dialog-actions>